import { PiChatTextDuotone } from "react-icons/pi";
import deal1 from '../assets/hotDeals/buybackOffers.png'
import deal2 from '../assets/hotDeals/exchangeOffers.png'
import deal3 from '../assets/hotDeals/refurbishedDeviceOffers.png'
import deal4 from '../assets/hotDeals/refairOffers.png'
import { toast } from 'react-hot-toast';

const HotDeals = () => {
    const handleAlert = () => {
        toast.error("The Online Services Currently Unavailable, Please visit or contact our store ");
        toast("Clear Your Queries By Chatting With Our Expert Team", {
            icon: <PiChatTextDuotone className="text-[#42C8B7]" size={24} />,
            duration: 10000,
        });
    }
    const Deals = [{
        deal: deal1,
        onclick: handleAlert
    },
    {
        deal: deal2,
        onclick: handleAlert
    },
    {
        deal: deal3,
        onclick: handleAlert
    },
    {
        deal: deal4,
        onclick: handleAlert
    },
    ]
    return (
        <div className="w-full bg-[#F7F7F7] mt-6 sm:mt-8 lg:mt-10 px-4 sm:px-6 ">
            <div className="w-full max-w-6xl mx-auto ">
                <h2 className="text-xl md:text-2xl font-bold">Hot Deals</h2>
                <h2 className="text-[10px] md:text-sm text-[#AAAAAB]">Exciting offers for more value   </h2>
                <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-2 mt-4">
                    {Deals.map((deal, index) => (
                        <div key={index} className="hover:scale-105 transition-all duration-300">
                            <button onClick={deal.onclick} className=""> <img src={deal.deal} alt={deal.deal} className="w-full " />
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default HotDeals;
